__turbopack_context__.v({
  "Footer": "rnk_JG_Footer",
});
